import React from "react";
import { operationsHealth } from "../../data/findings";
import { Sparkline } from "./Sparkline";
export function OperationsHealth() {
  return <figure className="border border-navy bg-ivory" aria-label="Payroll operations health, trailing twelve cycles" data-id="element-127" data-mp="2p2cy81pzjy8u">
      <div className="flex items-baseline justify-between gap-4 border-b border-navy px-6 py-4" data-id="element-128" data-mp="32trkqij3qhkn">
        <p className="eyebrow text-navy" data-id="element-129" data-mp="2xzdhjty7765f">Payroll operations health</p>
        <p className="text-[11px] tabular-nums text-charcoal/60" data-id="element-130" data-mp="3cojh5j0y6ydu">Trailing 12 cycles</p>
      </div>
      <ul data-id="element-131" data-mp="37qhw4sjyoozq">
        {operationsHealth.map(m => <li key={m.label} className="grid grid-cols-12 items-center gap-4 border-b border-stone px-6 py-5 last:border-b-0" data-id="element-132" data-mp="3lqj1ak79eil0">
            <div className="col-span-6 sm:col-span-5" data-id="element-133" data-mp="3hq8u547qdm4k">
              <p className="text-sm font-medium text-charcoal" data-id="element-134" data-mp="1rcrsfmwr82qm">{m.label}</p>
              <p className="mt-1 text-[11px] text-charcoal/60" data-id="element-135" data-mp="1reufpz6ivhrn">{m.note}</p>
            </div>
            <div className="hidden sm:col-span-4 sm:block" data-id="element-136" data-mp="1nczgd085jegi">
              <Sparkline values={m.series} data-id="element-137" data-mp="bk9yphvspguk" />
            </div>
            <p className="col-span-6 whitespace-nowrap text-right font-display text-3xl tabular-nums text-navy sm:col-span-3" data-id="element-138" data-mp="bhntvq0ahfg1">
              {m.direction === "down" && <span className="mr-1 text-2xl text-oxblood" aria-label="down" data-id="element-139" data-mp="lgd9td8mkptn">
                  ↓
                </span>}
              {m.value}
            </p>
          </li>)}
      </ul>
      <figcaption className="border-t border-navy px-6 py-3 text-[11px] leading-relaxed text-charcoal/60" data-id="element-140" data-mp="v9kban08vlog">
        Illustrative client profile, twelve cycles into a Constant engagement.
      </figcaption>
    </figure>;
}